/**
 * @generated SignedSource<<1a0a141fd172a599245e16d3921cd740>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InlineContentDrawerFooterFragment$data = {
  readonly content: {
    readonly usages: {
      readonly totalCount: number;
    };
    readonly " $fragmentSpreads": FragmentRefs<"ContentInstancesTooltipFragment">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"CurriculumDrawerFooterContentFragment" | "InlineContentDrawerSubmitButtonFragment">;
  readonly " $fragmentType": "InlineContentDrawerFooterFragment";
};
export type InlineContentDrawerFooterFragment$key = {
  readonly " $data"?: InlineContentDrawerFooterFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"InlineContentDrawerFooterFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InlineContentDrawerFooterFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentUsageNodeConnection",
          "kind": "LinkedField",
          "name": "usages",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ContentInstancesTooltipFragment"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CurriculumDrawerFooterContentFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InlineContentDrawerSubmitButtonFragment"
    }
  ],
  "type": "ContentUsage",
  "abstractKey": null
};

(node as any).hash = "704ee514593906cc7688bcb5a042e8fb";

export default node;
